import { getCloudinaryImgUrl, getCloudinarySrcSet } from '@finn/ui-utils';
import React from 'react';

import HeroFilters from './HeroFilters';
import { Hero2CosmicMetadata } from './metaData';

type Props = {
  data: Hero2CosmicMetadata;
  title: string;
};

export const HeroWithFilters: React.FC<Props> = ({ data, title }) => {
  if (!data) return null;

  const imgURL =
    'https://imgix.cosmicjs.com/9ee09850-2fe9-11f0-842a-c7ebc7727e7e-Home-Hero-Background-Image.jpg'; // TODO; replace in split hero after campaign ends
  const mobileImageUrl =
    'https://imgix.cosmicjs.com/84d4d9c0-2fea-11f0-842a-c7ebc7727e7e-Home-Hero-Background-Image-Mobile.jpg';

  const mobileSrcSet = getCloudinarySrcSet(mobileImageUrl, [480, 800]);
  const mobileSrc = getCloudinaryImgUrl(mobileImageUrl, { w: 480, dpr: 2 });

  const srcSet = getCloudinarySrcSet(imgURL, [1200, 1600]);
  const src = getCloudinaryImgUrl(imgURL, { w: 1200, dpr: 2 });

  return (
    <div className={'relative h-[622px] md:h-[732px] lg:h-[822px]'}>
      <img
        draggable={false}
        src={mobileSrc}
        srcSet={mobileSrcSet}
        alt={data.hero_image_alt_text}
        className={`absolute inset-0 -z-overlay size-full object-cover sm:hidden`}
      />
      <img
        draggable={false}
        src={src}
        srcSet={srcSet}
        alt={data.hero_image_alt_text}
        className={`absolute inset-0 -z-overlay hidden size-full object-cover sm:block`}
      />
      <div className="container" data-testid="hero2">
        <div
          className={
            '-mb-10 grid gap-4 sm:grid-cols-[400px_1fr] md:-mb-24 md:grid-cols-[500px_1fr]'
          }
        >
          <div className={'mt-[124px] w-full'}>
            <h1
              className={
                'relative mb-6 text-left text-white mobile-t2-semibold md:web-t2-semibold'
              }
              data-cy="hero-title"
            >
              {title}
            </h1>

            <HeroFilters primaryCTA={data.primary_cta} />
          </div>
        </div>
      </div>
    </div>
  );
};
